<template>
  <b-dropdown rnd-id="lang" hoverable aria-role="list">
    <!-- <img
      slot="trigger"
      :src="require(`@/assets/images/flags/${language.flag}.png`)"
      :alt="currentBusiness.bookingUrl"
    /> -->
    <label slot="trigger">Business</label>
    <b-dropdown-item
      v-for="business in business"
      :key="business.business.id"
      aria-role="listitem"
      @click="handleSetBusiness(business)"
    >
      <div class="media">
        <!-- <img class="media-left" src="@/assets/images/flags/de.png" alt="de" /> -->
        <div class="media-content">
          <p>{{ business.business.businessName }}</p>
        </div>
      </div>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import {
  getBusinesses,
  getCurrentBusiness,
  setCurrentBusiness,
  setRole,
} from "@/utils/auth";

export default {
  name: "business-select",
  computed: {
    business() {
      var businesses = getBusinesses();
      return businesses;
    },
    currentBusiness() {
      var currentBusiness = getCurrentBusiness();
      return currentBusiness;
    },
    language() {
      const locale = this.$store.getters.language;
      this.$moment.locale(locale);

      if (locale === "en") {
        return {
          flag: "en",
          lang: "English",
        };
      } else if (locale === "fr") {
        return {
          flag: "fr",
          lang: "Français",
        };
      } else if (locale === "de") {
        return {
          flag: "de",
          lang: "Deutsch",
        };
      } else if (locale === "it") {
        return {
          flag: "it",
          lang: "Italiano",
        };
      }
    },
  },
  methods: {
    handleSetBusiness(business) {
      setCurrentBusiness(business);
      setRole(business.role);
      window.location.reload();
    },
  },
};
</script>

<style lang="scss">
.navbar-item {
  img {
    width: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/business-select/BusinessSelect.vue